import { type PostContentObjectDetail, createPostContentObjectDetail } from 'models';
import { useMutation } from 'query';
import { repostContentObject } from '../../services';
import { useContentObjectCache } from '../cache';

export const useRepostContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<
    PostContentObjectDetail,
    { communityId: string; htmlContent?: string; objectId: string; textContent?: string }
  >({
    async mutationFn({ communityId, htmlContent, objectId, textContent }) {
      const response = await repostContentObject({
        post: {
          html_content: htmlContent,
          post_in_communities: [{ id: communityId }],
          shared_content_object_id: objectId,
          text_content: textContent,
        },
      });

      return createPostContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
